import { Box, BoxProps, CloseButton, SystemProps } from "@chakra-ui/react";
import { ReactElement, useMemo } from "react";
import { useDataSource, valueArray } from "../DataSource";
import { createEnvironment } from "../core/environment";
import Markdown from "./Markdown";

interface ArticleMarkdownProps extends BoxProps {
  markdownStyles?: SystemProps;
}

export default function ArticleMarkdown(
  props: ArticleMarkdownProps
): ReactElement {
  const { markdownStyles = {}, ...rest } = props;
  const { markdownTemplate, tempArticle, focused, setFocused } =
    useDataSource();

  const currentArticle = tempArticle ?? focused;

  const environment = useMemo(
    () =>
      currentArticle != null
        ? createEnvironment(
            Object.fromEntries(
              Object.entries(currentArticle.data).map(([key, value]) => [
                key,
                valueArray(value).join("; "),
              ])
            )
          )
        : null,
    [currentArticle]
  );

  return (
    <Box
      bg="transparent"
      opacity={currentArticle != null ? 1 : 0}
      height={currentArticle != null ? "fit-content" : "0"}
      {...rest}
    >
      {environment != null && (
        <Box position="relative" bg="white" py="4" ps="4" roundedTop="lg">
          <CloseButton
            position="absolute"
            top="4"
            right="4"
            onClick={() => setFocused(null)}
          />
          <Box pe="4">
            <Markdown
              template={markdownTemplate}
              environment={environment}
              {...markdownStyles}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
